import React, { Fragment } from 'react'
import Button from '../../Button'
import Icon, { IconType } from '../../Icon'
import { NoAttachmentsProps } from './../types'
import styles from '@bt-react/styles'
import componentStyles from './NoAttachments.module.scss'
import compareAsc from 'date-fns/compareAsc'
import subMinutes from 'date-fns/subMinutes'
import classNames from 'classnames'

const NoAttachments: React.FC<NoAttachmentsProps> = ({setView, webcastData, isCentral}) => {

    const syndication = (webcastData.syndication && Object.keys(webcastData.syndication).length > 0 && webcastData.syndication.syndicationIn) ? true : false
    const currentTime = new Date()
    const isLive = (webcastData.entryTime && webcastData.closeTime && compareAsc(subMinutes(new Date(webcastData.entryTime), 10), currentTime) <= 0  && compareAsc(currentTime, new Date(webcastData.closeTime)) <= 0) ? true : false

    return (
        <div className={classNames(styles['col-12'], styles['m-auto'], componentStyles['noattachments-container'])} data-bdd="no-attachments">
            <Icon dataBdd="no-attachments-icon" name={IconType.iconName.attachment} colour={IconType.colour.londonGrey} className={componentStyles['attachment-icon']}/>
            <h1 data-bdd="no-attachments-text" className={componentStyles['noattachments-header']}>{isLive ? "No attachments" : "No attachments yet"}</h1>
            {isLive &&
                <div data-bdd="no-attachments-message-text" className={componentStyles['noattachments-text']}>
                    Changes to attachments cannot be made starting 15 minutes before the live event. Please check back after the event has ended.
                </div>
            }
            {!syndication && !isLive &&
                <Fragment>
                    <div data-bdd="no-attachments-message-text" className={componentStyles['noattachments-text']}>Upload attachments for your audience to download and interact with.</div>
                
                    <Button 
                        onClick={()=>setView('add')}
                        dataBdd="add-attachment-button"
                        className={isCentral ? componentStyles['add-attachment-button'] : ''}
                    >
                        <Icon dataBdd="add-attachment-button-plus-icon" name={isCentral ? IconType.iconName.plusCircleRegular : IconType.iconName.plusCircle} colour={IconType.colour.white} className={classNames(componentStyles['add-icon'], {[componentStyles['add-icon-central']]: isCentral})} />
                        Add attachment
                    </Button>
                </Fragment>
            }
        </div>
    )

}

export default NoAttachments